(function () {
  var core = window.DPPThemeProduct || {}
  var formatMoney = core.formatMoney
  var normalizeToCents = core.normalizeToCents
  var escapeHtml = core.escapeHtml
  var getShopifyFeatures = core.getShopifyFeatures
  var replaceTokens = core.replaceTokens
  function isSingleVariantLabel(variantTitle) {
    var normalizedTitle = String(variantTitle || '').toLowerCase().replace(/\s+/g, ' ').trim()
    return /^(1|een)\s*[- ]?\s*(pack|stuk|stuks|piece|pcs|pc)$/.test(normalizedTitle)
  }

  function shouldHideBundleVariantTitle(variantTitle, variantId, firstVariantId) {
    if (!variantTitle || variantTitle === 'Default Title') return true
    if (isSingleVariantLabel(variantTitle)) return true
    return !!(variantId && firstVariantId && String(variantId) === String(firstVariantId))
  }

  function buildVariantDisplayTitle(productTitle, variantTitle, variantId, firstVariantId) {
    return shouldHideBundleVariantTitle(variantTitle, variantId, firstVariantId) ? productTitle : (productTitle + ' - ' + variantTitle)
  }

  function buildBundleDisplayTitle(bundleVariant) {
    var productTitle = bundleVariant && bundleVariant.bundleProductTitle ? bundleVariant.bundleProductTitle : ''
    var variantTitle = bundleVariant && bundleVariant.bundleVariantTitle ? bundleVariant.bundleVariantTitle : ''
    var variantId = bundleVariant && bundleVariant.bundleVariantGid ? bundleVariant.bundleVariantGid : ''
    var firstVariantId = bundleVariant && bundleVariant.bundleFirstVariantGid ? bundleVariant.bundleFirstVariantGid : ''
    return buildVariantDisplayTitle(productTitle, variantTitle, variantId, firstVariantId)
  }

  function normalizeBundleVariantNode(node) {
    var product = node && node.product ? node.product : {}
    var components = node && node.components && Array.isArray(node.components.nodes)
      ? node.components.nodes.map(function (component) {
          var componentVariant = component && component.productVariant ? component.productVariant : {}
          var componentProduct = componentVariant && componentVariant.product ? componentVariant.product : {}
          var componentFirstVariant = componentProduct && componentProduct.variants && Array.isArray(componentProduct.variants.nodes)
            ? componentProduct.variants.nodes[0]
            : null
          var componentVariantTitle = componentVariant && componentVariant.title && componentVariant.title !== 'Default Title'
            ? componentVariant.title
            : ''

          return {
            quantity: component && component.quantity ? component.quantity : 0,
            productTitle: componentProduct.title || '',
            productUrl: componentProduct.onlineStoreUrl || (componentProduct.handle ? '/products/' + componentProduct.handle : ''),
            variantGid: componentVariant && componentVariant.id ? componentVariant.id : '',
            firstVariantGid: componentFirstVariant && componentFirstVariant.id ? componentFirstVariant.id : '',
            variantTitle: componentVariantTitle,
            priceCents: normalizeToCents(componentVariant && componentVariant.price ? componentVariant.price.amount : 0),
            compareAtPriceCents: normalizeToCents(componentVariant && componentVariant.compareAtPrice ? componentVariant.compareAtPrice.amount : 0),
            imageUrl: componentProduct.featuredImage && componentProduct.featuredImage.url ? componentProduct.featuredImage.url : '',
            imageAlt: componentProduct.featuredImage && componentProduct.featuredImage.altText ? componentProduct.featuredImage.altText : (componentProduct.title || '')
          }
        })
      : []

    return {
      bundleVariantGid: node && node.id ? node.id : '',
      bundleVariantTitle: node && node.title ? node.title : '',
      bundleFirstVariantGid: product && product.variants && Array.isArray(product.variants.nodes) && product.variants.nodes[0] ? product.variants.nodes[0].id : '',
      bundleAvailable: !!(node && node.availableForSale),
      bundlePriceCents: normalizeToCents(node && node.price ? node.price.amount : 0),
      bundleCompareAtPriceCents: normalizeToCents(node && node.compareAtPrice ? node.compareAtPrice.amount : 0),
      bundleProductTitle: product && product.title ? product.title : '',
      bundleProductUrl: product && product.onlineStoreUrl ? product.onlineStoreUrl : (product && product.handle ? '/products/' + product.handle : ''),
      bundleImageUrl: product && product.featuredImage && product.featuredImage.url ? product.featuredImage.url : '',
      bundleImageAlt: product && product.featuredImage && product.featuredImage.altText ? product.featuredImage.altText : (product && product.title ? product.title : ''),
      bundleComponents: components
    }
  }

  function fetchBundleVariantDetails(bundleVariantGids) {
    var ids = (bundleVariantGids || []).filter(function (id, index, list) {
      return id && list.indexOf(id) === index
    })
    if (ids.length === 0) return Promise.resolve({})

    var headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
    var features = getShopifyFeatures()
    if (features.accessToken) headers['X-Shopify-Storefront-Access-Token'] = features.accessToken

    return fetch('/api/2025-10/graphql.json', {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({
        query: 'query BundleVariantDetails($ids: [ID!]!) { nodes(ids: $ids) { ... on ProductVariant { id title availableForSale price { amount currencyCode } compareAtPrice { amount currencyCode } product { title handle onlineStoreUrl featuredImage { url altText } variants(first: 1) { nodes { id } } } components(first: 25) { nodes { quantity productVariant { id title price { amount currencyCode } compareAtPrice { amount currencyCode } product { title handle onlineStoreUrl featuredImage { url altText } variants(first: 1) { nodes { id } } } } } } } } } }',
        variables: { ids: ids }
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('bundle_variant_request_failed')
        return response.json()
      })
      .then(function (payload) {
        if (payload && Array.isArray(payload.errors) && payload.errors.length > 0) {
          throw new Error('bundle_variant_graphql_failed')
        }

        return ((payload && payload.data && payload.data.nodes) || []).reduce(function (accumulator, node) {
          if (!node || !node.id) return accumulator
          accumulator[node.id] = normalizeBundleVariantNode(node)
          return accumulator
        }, {})
      })
  }

  function renderBundleComponentMarkup(bundleVariant, quantityTemplate) {
    var components = bundleVariant && Array.isArray(bundleVariant.bundleComponents) ? bundleVariant.bundleComponents : []
    if (components.length === 0) return ''

    return components.map(function (component) {
      var componentTitle = buildVariantDisplayTitle(component.productTitle, component.variantTitle, component.variantGid, component.firstVariantGid)
      var quantityLabel = replaceTokens(quantityTemplate || '__QUANTITY__x', {
        QUANTITY: String(component.quantity || 0)
      })

      return '' +
        '<div class="grid grid-cols-[56px_minmax(0,1fr)] gap-3 rounded-dppsm border border-dpp-border bg-dpp-surfaceSoft/55 p-3">' +
        (component.productUrl
          ? '<a class="overflow-hidden rounded-dppsm bg-white" href="' + escapeHtml(component.productUrl) + '">' +
            (component.imageUrl
              ? '<img class="h-14 w-14 object-contain bg-white p-1.5" src="' + escapeHtml(component.imageUrl) + '" alt="' + escapeHtml(component.imageAlt || componentTitle) + '" loading="lazy">'
              : '<div class="h-14 w-14 bg-white"></div>') +
            '</a>'
          : (component.imageUrl
              ? '<img class="h-14 w-14 rounded-dppsm object-contain bg-white p-1.5" src="' + escapeHtml(component.imageUrl) + '" alt="' + escapeHtml(component.imageAlt || componentTitle) + '" loading="lazy">'
              : '<div class="h-14 w-14 rounded-dppsm bg-white"></div>')) +
        '<div class="grid gap-1">' +
        (component.productUrl
          ? '<a class="text-sm font-bold leading-snug text-dpp-text hover:text-dpp-teal" href="' + escapeHtml(component.productUrl) + '">' + escapeHtml(componentTitle) + '</a>'
          : '<p class="text-sm font-bold leading-snug text-dpp-text">' + escapeHtml(componentTitle) + '</p>') +
        '<span class="text-xs font-semibold uppercase tracking-[0.18em] text-dpp-muted">' + escapeHtml(quantityLabel) + '</span>' +
        '</div>' +
        '</div>'
    }).join('')
  }

  function getBundleOptionLabel(value) {
    return String(value || '')
      .replace(/\s+-\s+Default Title/g, '')
      .replace(/\s+\+\s+/g, ' + ')
      .trim()
  }

  function getBundleStepValue(entry, stepType) {
    return entry && entry[stepType + 'Value'] ? String(entry[stepType + 'Value']).trim() : ''
  }

  window.DPPThemeProductBundles = Object.assign(window.DPPThemeProductBundles || {}, {
    buildVariantDisplayTitle: buildVariantDisplayTitle,
    buildBundleDisplayTitle: buildBundleDisplayTitle,
    normalizeBundleVariantNode: normalizeBundleVariantNode,
    fetchBundleVariantDetails: fetchBundleVariantDetails,
    renderBundleComponentMarkup: renderBundleComponentMarkup,
    getBundleOptionLabel: getBundleOptionLabel,
    getBundleStepValue: getBundleStepValue
  })
})()
